import Comparator from "./comparator/PluginSetup.js";
import LogicalConditionFilterConverter from "./LogicalConditionFilterConverter.js";
import AttributeConditionFilterConverter from "../../filters/filter/AttributeConditionFilterConverter.js";
import FilterConditionFilterConverter from "./FilterConditionFilterConverter.js";
export default {
  install(molten) {
    Comparator.install(molten);
    molten.addPlugin('ImagineHistoryConditionFilterConverter', FilterConditionFilterConverter);
    molten.addPlugin('ImagineHistoryConditionFilterConverter', LogicalConditionFilterConverter);
    molten.addPlugin('ImagineHistoryConditionFilterConverter', AttributeConditionFilterConverter);
  }
};